module.exports = __webpack_public_path__ + "img/A1F6.119d146f.jpg";